import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import CenterActions, { CenterRedux,CenterTypes } from '../Redux/CenterRedux'
import { InventoryTypes } from '../Redux/InventoryRedux'

const centerCrudObservable = createCRUDObservable({
  mainRedux: CenterRedux,
  reduxPath: 'centers',
  dataHandlers: {
    get: response => response.data.data,
  },
})

const virtualCheckOutEpic = (action$, store, { Api }) =>
  action$.ofType(InventoryTypes.postCheckOutSuccess)
    .flatMap(({ checkin, data }) => {
      if (checkin.is_virtual_center) {
        return [CenterActions.getRequest({}, true)]
      }
      return []
    })

    
const getCenterBycontractEpic = (action$, store, { Api }) => (
  action$.ofType(CenterTypes.getCentersByContractRequest)
  .mergeMap(({ contractId }) => (
      Api.centers.getCenterByContract(contractId)
      .then(response => CenterActions.getCentersByContractSuccess(response.data.data))
      .catch(err => CenterActions.getCentersByContractSuccess(err))
  ))
)

export const centerObservers = Object.assign({}, centerCrudObservable.observers, {})

export const centerEpic = combineEpics(
  centerCrudObservable.epic,
  getCenterBycontractEpic,
  virtualCheckOutEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CenterObservable.js